import * as React from 'react';
import styled from 'styled-components';
import { Entity } from '../../../data/types';
import { Column } from '../../layout/Column';
import { Icon } from '../../shared/Icon';

interface IProps {
  iconName?: string;
  text: string;
  children?: React.ReactNode;
  entity?: Entity;
}
const Message = (props: IProps): React.ReactElement => {
  return (
    <MessageWrapper>
      <ErrorCard>
        <Column style={{ height: '100%', justifyContent: 'center' }}>
          {props.iconName ? (
            <Icon name={props.iconName} style={{ fontSize: '5em' }} />
          ) : null}
          <h5>{props.text}</h5>
          {props.children}
        </Column>
      </ErrorCard>
    </MessageWrapper>
  );
};
interface IErrorMessageProps {
  iconName?: string;
  text: string;
  children?: React.ReactNode;
}

export const ErrorMessage = (props: IErrorMessageProps): React.ReactElement => {
  return (
    <MessageWrapper>
      <ErrorCard>
        <Column style={{ alignItems: 'center' }}>
          {props.iconName ? (
            <Icon name={props.iconName} style={{ fontSize: '8rem' }} />
          ) : null}
          <h5>{props.text}</h5>
          <ErrorChildren>{props.children}</ErrorChildren>
        </Column>
      </ErrorCard>
    </MessageWrapper>
  );
};

const ErrorChildren = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  & > * {
    margin-left: 0 !important;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ErrorCard = styled.div`
  border: 4px solid var(--color-material-500-red);
  background-color: var(--color-surface-1);
  padding: 20px;
  border-radius: 10px;
  min-width: 50%;
`;

const MessageWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;
